import { useCallback, useEffect, useState } from "react";
import useUser from "./useUser";
import { ping } from "services/ping";
import { refreshWebapp } from "services/buildVersion";
import { clearUserSession } from "services/authUtil";
import { useNavigate } from "react-router";
import TalaeraRoutes from "components/routes/TalaeraRoutes";
import { logError } from "services/logging";
import { SignInLocationState } from "pages/SignIn/SignIn";

const SESSION_CHECK_INTERVAL = 1000 * 30;

export default function useHeartbeat() {
  const user = useUser();
  const navigate = useNavigate();

  const [apiResponding, setApiResponding] = useState(true);

  const userId = user?.id ?? null;

  const pingServer = useCallback(() => {
    ping(
      response => {
        setApiResponding(true);

        if (response.user && response.user.id !== userId) {
          refreshWebapp();
        } else if (!response.user && userId) {
          clearUserSession();
          const state: SignInLocationState = {
            sessionEpired: true,
          };
          navigate(TalaeraRoutes.SIGN_IN.path, {
            state,
          });
        }
      },
      error => {
        setApiResponding(false);
        logError(error);
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    const id = setInterval(pingServer, SESSION_CHECK_INTERVAL);
    return () => clearInterval(id);
  }, [pingServer]);

  return { apiResponding, pingServer };
}
